import React, { useCallback, useEffect, useState } from 'react';
import api from '../services/api';
import './HastaCari.css';

// BANKO MODÜLÜ — HASTA CARİ HESAPLARI (kullanıcı talebi: 2026-09-21).
// VB6 karşılığı: Banko_VB6\CAR_H.frm.
//
// Solda hasta arama, sağda hastanın cari hareketleri (faturalar BORÇ, tahsilatlar ALACAK),
// yürüyen bakiye ve toplamlar. Alt şeritte tahsilat / ödeme / hareket iptali / Excel.

const para = (v) => (Number(v) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const trTarih = (d) => (d ? `${String(d).slice(8, 10)}.${String(d).slice(5, 7)}.${String(d).slice(0, 4)}` : '');

export default function HastaCari() {
  const [arama, setArama] = useState('');
  const [sonuc, setSonuc] = useState([]);
  const [secili, setSecili] = useState(null);
  const [cari, setCari] = useState(null);
  const [bas, setBas] = useState('');
  const [bit, setBit] = useState('');
  const [iptalliler, setIptalliler] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');
  // Tahsilat / ödeme penceresi
  const [pencere, setPencere] = useState(null);      // { tahsilat: true|false }
  const [hesaplar, setHesaplar] = useState(null);
  const [tutar, setTutar] = useState('');
  const [tur, setTur] = useState('nakit');
  const [hesapKod, setHesapKod] = useState(0);
  const [aciklama, setAciklama] = useState('');
  const [belgeNo, setBelgeNo] = useState('');
  const [eftYapan, setEftYapan] = useState('');
  const [islemde, setIslemde] = useState(false);
  // Tahakkuk penceresi (VB6 SSPanel11)
  const [tahakkuk, setTahakkuk] = useState(null);    // { borc: true|false }
  // Bakiyeli hastalar penceresi (VB6 SSPanel3)
  const [bakiyeli, setBakiyeli] = useState(null);    // { durum, liste, toplam }
  const [bakiyeliDurum, setBakiyeliDurum] = useState('borclu');

  useEffect(() => {
    if (!bilgi) return undefined;
    const z = setTimeout(() => setBilgi(''), 7000);
    return () => clearTimeout(z);
  }, [bilgi]);

  const ara = async (e) => {
    if (e) e.preventDefault();
    const q = arama.trim();
    if (q.length < 2) { setHata('Aramak için en az 2 karakter yazınız.'); return; }
    setHata('');
    try {
      const p = /^\d+$/.test(q) ? { kayitNo: Number(q) } : { ad: q };
      const { data } = await api.get('/banko/hasta/ara', { params: p });
      setSonuc(data);
      if (data.length === 0) setBilgi('Bu bilgilerle hasta bulunamadı.');
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hasta araması yapılamadı.');
    }
  };

  const cariGetir = useCallback(async (kayitNo) => {
    setYukleniyor(true); setHata('');
    try {
      const { data } = await api.get(`/banko/cari/${kayitNo}`, {
        params: { bas: bas || undefined, bit: bit || undefined, iptalliler },
      });
      setCari(data);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Cari hesap alınamadı.');
      setCari(null);
    } finally {
      setYukleniyor(false);
    }
  }, [bas, bit, iptalliler]);

  useEffect(() => {
    if (secili?.kayitNo) cariGetir(secili.kayitNo);
  }, [secili, cariGetir]);

  // Kasa / POS / banka listeleri ve sıradaki belge numaraları ekran açılırken gelir.
  useEffect(() => {
    api.get('/banko/cari/hesaplar')
      .then(({ data }) => setHesaplar(data))
      .catch(() => setHesaplar({ kasa: null, kasalar: [], kartlar: [], bankalar: [], belgeNolari: {} }));
  }, []);

  // VB6: tahsilat/ödeme penceresi açılırken belge no sayaçtan gelir, kasa kullanıcının veznesidir.
  const pencereAc = (tahsilat) => {
    if (!cari) return;
    setPencere({ tahsilat });
    setTutar(tahsilat && cari.bakiye > 0 ? String(cari.bakiye) : '');
    setTur('nakit');
    setHesapKod(hesaplar?.kasa?.kod || 0);
    setBelgeNo(tahsilat ? (hesaplar?.belgeNolari?.tahsilat || '') : (hesaplar?.belgeNolari?.odeme || ''));
    setAciklama(''); setEftYapan(''); setHata('');
  };

  const tahakkukAc = () => {
    if (!cari) return;
    setTahakkuk({ borc: true });
    setTutar(''); setAciklama(''); setHata('');
    setBelgeNo(hesaplar?.belgeNolari?.tahakkuk || '');
  };

  // İşlem türü değişince belge no da o sayaçtan gelir (VB6 Command6).
  const turDegis = (yeni) => {
    setTur(yeni);
    setHesapKod(yeni === 'nakit' ? (hesaplar?.kasa?.kod || 0) : 0);
    if (!pencere) return;
    const b = hesaplar?.belgeNolari;
    if (!b) return;
    setBelgeNo(pencere.tahsilat ? (yeni === 'banka' ? b.havale : b.tahsilat) : b.odeme);
  };

  const bakiyeliGetir = async (durum) => {
    setBakiyeliDurum(durum); setHata('');
    try {
      const { data } = await api.get('/banko/cari/bakiyeli', { params: { durum } });
      setBakiyeli({ durum, ...data });
    } catch (err) {
      setHata(err.response?.data?.hata || 'Bakiyeli hasta listesi alınamadı.');
    }
  };

  const bakiyeleriYenile = async () => {
    if (!window.confirm('Tüm hasta kartlarının bakiyesi cari hareketlerden yeniden hesaplanacak.\n\nOnaylıyor musunuz?')) return;
    setIslemde(true); setHata('');
    try {
      const { data } = await api.post('/banko/cari/bakiyeleri-yenile');
      setBilgi(data.mesaj);
      await bakiyeliGetir(bakiyeliDurum);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Bakiyeler yenilenemedi.');
    } finally { setIslemde(false); }
  };

  const tahakkukKaydet = async () => {
    if (!tahakkuk || !cari) return;
    const t = Number(String(tutar).replace(',', '.')) || 0;
    if (t <= 0) { setHata('Lütfen TUTAR bilgisini giriniz.'); return; }
    if (!belgeNo.trim()) { setHata('Lütfen BELGE NO bilgisini giriniz.'); return; }
    const onay = window.confirm(
      `${cari.adSoy} · ${para(t)} TL ${tahakkuk.borc ? 'BORÇ' : 'ALACAK'} tahakkuku yapılacak.\n\nOnaylıyor musunuz?`);
    if (!onay) return;
    setIslemde(true); setHata('');
    try {
      const { data } = await api.post(`/banko/cari/${cari.kayitNo}/tahakkuk`,
        { tutar: t, borc: tahakkuk.borc, belgeNo, aciklama });
      setBilgi(`Tahakkuk kaydedildi · Belge No: ${data.belgeNo}`);
      setTahakkuk(null);
      await cariGetir(cari.kayitNo);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Tahakkuk yapılamadı.');
    } finally { setIslemde(false); }
  };

  // VB6 Command21: tahsilat dekontu (yazdırılabilir sayfa).
  const dekontYazdir = (h) => {
    if (![5, 7, 2].includes(h.kaynakKod)) { setHata('Seçtiğiniz kayıt bir TAHSİLAT değil.'); return; }
    const p = window.open('', '_blank', 'width=700,height=600');
    if (!p) { setHata('Yazdırma penceresi açılamadı; açılır pencere engelini kapatınız.'); return; }
    p.document.write(`<!doctype html><html lang="tr"><head><meta charset="utf-8"><title>Tahsilat Dekontu</title>
<style>
 body{font-family:Segoe UI,Arial,sans-serif;font-size:13px;color:#1F2F46;margin:26px}
 h1{font-size:18px;margin:0 0 4px} .ust{border-bottom:2px solid #1F2F46;padding-bottom:8px;margin-bottom:12px}
 .k{display:grid;grid-template-columns:150px 1fr;gap:4px 12px} .k b{color:#6B7A8C;font-weight:600}
 .tutar{margin-top:18px;font-size:20px;font-weight:700;text-align:right}
 .imza{margin-top:48px;display:flex;justify-content:space-between}
 @media print{body{margin:10mm}}
</style></head><body>
 <div class="ust"><h1>TAHSİLAT DEKONTU</h1><div>${h.kaynakEvrak}</div></div>
 <div class="k">
  <b>Hasta</b><span>${cari.adSoy} (${cari.kayitNo})</span>
  <b>Tarih / Saat</b><span>${trTarih(h.tar)} ${h.saat}</span>
  <b>Evrak No</b><span>${h.evrakNo || '-'}</span>
  <b>Hesap</b><span>${h.karsHesap || '-'}</span>
  <b>Açıklama</b><span>${h.aciklama || '-'}</span>
  <b>İşlemi Yapan</b><span>${h.who || '-'}</span>
 </div>
 <div class="tutar">${para(h.borc || h.alacak)} TL</div>
 <div class="imza"><div>Teslim Eden</div><div>Teslim Alan</div></div>
 <script>window.onload=function(){window.print();};${'<'}/script></body></html>`);
    p.document.close();
  };

  const kaydet = async () => {
    if (!pencere || !cari) return;
    const t = Number(String(tutar).replace(',', '.')) || 0;
    if (t <= 0) { setHata('Tutar sıfırdan büyük olmalıdır.'); return; }
    const onay = window.confirm(
      `${cari.adSoy} · ${para(t)} TL ${pencere.tahsilat ? 'TAHSİLAT' : 'ÖDEME'} yapılacak.\n\nOnaylıyor musunuz?`);
    if (!onay) return;

    setIslemde(true); setHata('');
    try {
      const yol = pencere.tahsilat ? 'tahsilat' : 'odeme';
      const { data } = await api.post(`/banko/cari/${cari.kayitNo}/${yol}`,
        { tutar: t, tur, hesapKod, belgeNo, eftYapan, aciklama });
      setBilgi(`${pencere.tahsilat ? 'Tahsilat' : 'Ödeme'} kaydedildi · Makbuz No: ${data.makbuzNo}`);
      setPencere(null);
      await cariGetir(cari.kayitNo);
    } catch (err) {
      setHata(err.response?.data?.hata || 'İşlem yapılamadı.');
    } finally {
      setIslemde(false);
    }
  };

  // Tahsilat / ödeme hareketini iptal eder (fatura satırı iptal edilemez).
  const hareketIptal = async (h) => {
    const onay = window.confirm(
      `${trTarih(h.tar)} tarihli ${para(h.borc || h.alacak)} TL tutarındaki `
      + `"${h.aciklama || h.kaynakEvrak}" hareketi İPTAL edilecek.\n`
      + 'Kayıt silinmez, iptal olarak işaretlenir ve bakiyelerden düşülür.\n\nOnaylıyor musunuz?');
    if (!onay) return;
    setHata('');
    try {
      await api.post(`/banko/cari/${cari.kayitNo}/hareket/${h.id}/iptal`);
      setBilgi('Hareket iptal edildi.');
      await cariGetir(cari.kayitNo);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Hareket iptal edilemedi.');
    }
  };

  const excelAktar = async () => {
    if (!cari || cari.hareketler.length === 0) { setHata('Listeniz boş!'); return; }
    setBilgi('Excel hazırlanıyor...');
    const ExcelJS = (await import('exceljs')).default;
    const kitap = new ExcelJS.Workbook();
    kitap.creator = 'FizyofiPlus';
    const sayfa = kitap.addWorksheet('Hasta Cari', { views: [{ state: 'frozen', ySplit: 3 }] });
    const sutun = [
      { header: 'Tarih', key: 'tar', width: 12 },
      { header: 'Saat', key: 'saat', width: 8 },
      { header: 'Açıklama', key: 'ack', width: 38 },
      { header: 'Evrak No', key: 'evrak', width: 14 },
      { header: 'Karşı Hesap', key: 'kars', width: 24 },
      { header: 'Borç', key: 'borc', width: 14 },
      { header: 'Alacak', key: 'alacak', width: 14 },
      { header: 'Bakiye', key: 'bakiye', width: 14 },
      { header: 'Kullanıcı', key: 'who', width: 16 },
      { header: 'Durum', key: 'durum', width: 10 },
    ];
    sayfa.columns = sutun;
    sayfa.spliceRows(1, 0, [], []);
    sayfa.getCell('A1').value = `FizyofiPlus · Hasta Cari Hesabı — ${cari.adSoy} (${cari.kayitNo})`;
    sayfa.getCell('A1').font = { size: 14, bold: true, color: { argb: 'FF1F2F46' } };
    sayfa.getCell('A2').value =
      `Borç ${para(cari.toplamBorc)} · Alacak ${para(cari.toplamAlacak)} · Bakiye ${para(cari.bakiye)} TL`;
    sayfa.getCell('A2').font = { size: 10, color: { argb: 'FF6B7A8C' } };
    const bs = sayfa.getRow(3);
    sutun.forEach((s, i) => { bs.getCell(i + 1).value = s.header; });
    bs.eachCell(c => {
      c.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F2F46' } };
    });
    cari.hareketler.forEach((h, i) => {
      const r = sayfa.addRow({
        tar: trTarih(h.tar), saat: h.saat,
        ack: h.aciklama || h.kaynakEvrak, evrak: h.evrakNo, kars: h.karsHesap,
        borc: h.borc, alacak: h.alacak, bakiye: h.bakiye, who: h.who,
        durum: h.iptal ? 'İPTAL' : '',
      });
      ['F', 'G', 'H'].forEach(k => { r.getCell(k).numFmt = '#,##0.00'; });
      if (i % 2) r.eachCell(c => { c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF3F6FA' } }; });
    });
    sayfa.autoFilter = { from: { row: 3, column: 1 }, to: { row: 3, column: sutun.length } };
    const veri = await kitap.xlsx.writeBuffer();
    const url = URL.createObjectURL(new Blob([veri], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `hasta-cari-${cari.kayitNo}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
    setBilgi('Cari hareketler Excel\'e aktarıldı.');
  };

  return (
    <div className="hc">
      <div className="hc-serit">
        <h2 className="hc-baslik">💳 Hasta Cari Hesapları <span>· Banko Modülü</span></h2>
        <div className={`hc-durum ${hata ? 'hata' : bilgi ? 'bilgi' : ''}`}>
          {hata || bilgi || 'Faturalar BORÇ, tahsilatlar ALACAK olarak işlenir; bakiye borç − alacaktır.'}
        </div>
      </div>

      <div className="hc-duzen">
        <div className="hc-sol card">
          <span className="hc-kutu-baslik">Hasta Ara</span>
          <form onSubmit={ara} className="hc-arama">
            <input value={arama} onChange={e => setArama(e.target.value)}
              placeholder="Ad soyad ya da hasta no" />
            <button type="submit" className="btn btn-primary">Ara</button>
          </form>
          <div className="hc-sonuc">
            <table>
              <thead><tr><th>No</th><th>Hasta Adı</th><th>Telefon</th></tr></thead>
              <tbody>
                {sonuc.length === 0 && <tr><td colSpan={3} className="hc-bos">Arama yapınız.</td></tr>}
                {sonuc.map(h => (
                  <tr key={h.kayitNo} className={secili?.kayitNo === h.kayitNo ? 'secili' : ''}
                    onClick={() => setSecili(h)}>
                    <td>{h.kayitNo}</td>
                    <td className="hc-ad">{h.adSoy}</td>
                    <td>{h.cepTel || h.tel || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="hc-sag">
          {!cari && <div className="card hc-bos-not">Soldan bir hasta seçiniz.</div>}
          {cari && (
            <>
              <div className="card hc-ozet">
                <div className="hc-hasta">
                  <strong>{cari.adSoy}</strong>
                  <span>Hasta No: {cari.kayitNo}{cari.tcKimlik ? ` · TC: ${cari.tcKimlik}` : ''}</span>
                  <span>{cari.telefon}</span>
                </div>
                <div className="hc-rakamlar">
                  <div><span>BORÇ</span><b>{para(cari.toplamBorc)}</b></div>
                  <div><span>ALACAK</span><b className="yesil">{para(cari.toplamAlacak)}</b></div>
                  <div className={cari.bakiye > 0 ? 'borclu' : ''}>
                    <span>BAKİYE</span><b>{para(cari.bakiye)}</b>
                  </div>
                </div>
                <div className="hc-filtre">
                  <label><span>Başlangıç</span>
                    <input type="date" value={bas} onChange={e => setBas(e.target.value)} /></label>
                  <label><span>Bitiş</span>
                    <input type="date" value={bit} onChange={e => setBit(e.target.value)} /></label>
                  <label className="hc-onay">
                    <input type="checkbox" checked={iptalliler} onChange={e => setIptalliler(e.target.checked)} />
                    <span>İptalleri göster</span>
                  </label>
                  <button type="button" className="btn btn-secondary" onClick={excelAktar}>📊 Excel</button>
                </div>
                <div className="hc-islemler">
                  <button type="button" className="hc-islem tahsilat" onClick={() => pencereAc(true)}
                    disabled={!cari.yetkiler?.tahsilat}
                    title={cari.yetkiler?.tahsilat ? 'Hastadan para al' : 'Bu işlem için yetkili değilsiniz.'}>
                    <b>💰</b><span>TAHSİLAT AL</span>
                  </button>
                  <button type="button" className="hc-islem odeme" onClick={() => pencereAc(false)}
                    disabled={!cari.yetkiler?.tahsilat}
                    title={cari.yetkiler?.tahsilat ? 'Hastaya ödeme / iade yap (yalnız nakit)' : 'Bu işlem için yetkili değilsiniz.'}>
                    <b>↩️</b><span>ÖDEME / İADE</span>
                  </button>
                  <button type="button" className="hc-islem tahakkuk" onClick={tahakkukAc}
                    disabled={!cari.yetkiler?.tahsilat}
                    title={cari.yetkiler?.tahsilat ? 'Manuel borç / alacak tahakkuku' : 'Bu işlem için yetkili değilsiniz.'}>
                    <b>📝</b><span>TAHAKKUK</span>
                  </button>
                  <button type="button" className="hc-islem bakiyeli" onClick={() => bakiyeliGetir(bakiyeliDurum)}>
                    <b>📋</b><span>BAKİYELİ HASTALAR</span>
                  </button>
                </div>
              </div>

              <div className="card hc-liste">
                {yukleniyor && <div className="loading">Yükleniyor...</div>}
                {!yukleniyor && (
                  <table>
                    <thead>
                      <tr>
                        <th>Tarih</th><th>Saat</th><th>Açıklama</th><th>Evrak No</th><th>Karşı Hesap</th>
                        <th className="sag">Borç</th><th className="sag">Alacak</th><th className="sag">Bakiye</th>
                        <th>Kullanıcı</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {cari.devirBorc !== 0 && (
                        <tr className="hc-devir">
                          <td colSpan={7}>Devir bakiyesi</td>
                          <td className="sag">{para(cari.devirBorc)}</td>
                          <td />
                        </tr>
                      )}
                      {cari.hareketler.length === 0 && (
                        <tr><td colSpan={10} className="hc-bos">Bu hastanın cari hareketi yok.</td></tr>
                      )}
                      {cari.hareketler.map(h => (
                        <tr key={h.id} className={`${h.iptal ? 'iptalli' : ''} ${h.fatura ? 'fatura' : ''}`}>
                          <td>{trTarih(h.tar)}</td>
                          <td>{h.saat}</td>
                          <td className="hc-ad" title={h.aciklamaManuel}>{h.aciklama || h.kaynakEvrak}</td>
                          <td>{h.evrakNo}</td>
                          <td>{h.karsHesap}</td>
                          <td className="sag">{h.borc ? para(h.borc) : ''}</td>
                          <td className="sag yesil">{h.alacak ? para(h.alacak) : ''}</td>
                          <td className="sag">{para(h.bakiye)}</td>
                          <td>{h.who}</td>
                          <td className="hc-iptal-sutun">
                            {[2, 5, 7].includes(h.kaynakKod) && !h.iptal && (
                              <button type="button" className="hc-dekont" onClick={() => dekontYazdir(h)}
                                title="Tahsilat dekontunu yazdır">🖨️</button>
                            )}
                            {h.silinebilir && cari.yetkiler?.hareketSil && (
                              <button type="button" onClick={() => hareketIptal(h)}
                                title="Bu hareketi sil (iptal olarak işaretlenir)">✕</button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {pencere && cari && (
        <div className="hc-modal-zemin" onClick={() => setPencere(null)} role="presentation">
          <div className="hc-modal" onClick={e => e.stopPropagation()} role="presentation">
            <div className="hc-modal-bas">
              <strong>{pencere.tahsilat ? 'TAHSİLAT AL' : 'ÖDEME / İADE'} — {cari.adSoy}</strong>
              <button type="button" onClick={() => setPencere(null)}>✕</button>
            </div>
            <div className="hc-modal-govde">
              <p className="hc-modal-not">
                Güncel bakiye: <b>{para(cari.bakiye)} TL</b>
                {cari.bakiye > 0 ? ' (hasta borçlu)' : cari.bakiye < 0 ? ' (hastaya iade edilecek)' : ''}
              </p>
              <label className="hc-alan"><span>Tutar (TL)</span>
                <input type="number" step="0.01" min={0} autoFocus value={tutar}
                  onChange={e => setTutar(e.target.value)} /></label>
              {/* VB6: ödeme/iade yalnızca NAKİT yapılır. */}
              {pencere.tahsilat && (
                <div className="hc-secim">
                  {[['nakit', 'Nakit'], ['kart', 'Kredi Kartı'], ['banka', 'Banka / Havale']].map(([k, ad]) => (
                    <button key={k} type="button" className={`hc-sec ${tur === k ? 'aktif' : ''}`}
                      onClick={() => turDegis(k)}>{ad}</button>
                  ))}
                </div>
              )}
              {tur === 'nakit' && (
                <label className="hc-alan"><span>Nakit Kasa</span>
                  <select value={hesapKod} onChange={e => setHesapKod(Number(e.target.value))}>
                    <option value={0}>Seçiniz...</option>
                    {(hesaplar?.kasalar || []).map(h => (
                      <option key={h.kod} value={h.kod}>{h.adi}</option>
                    ))}
                  </select>
                </label>
              )}
              {tur !== 'nakit' && (
                <label className="hc-alan"><span>{tur === 'kart' ? 'Kredi Kartı Bankası (POS)' : 'Banka Hesabı'}</span>
                  <select value={hesapKod} onChange={e => setHesapKod(Number(e.target.value))}>
                    <option value={0}>Seçiniz...</option>
                    {((tur === 'kart' ? hesaplar?.kartlar : hesaplar?.bankalar) || []).map(h => (
                      <option key={h.kod} value={h.kod}>{h.adi}</option>
                    ))}
                  </select>
                </label>
              )}
              {tur === 'banka' && (
                <label className="hc-alan"><span>EFT Yapan</span>
                  <input value={eftYapan} maxLength={20} onChange={e => setEftYapan(e.target.value)}
                    placeholder="Dekontta yazdığı gibi" /></label>
              )}
              <label className="hc-alan"><span>Belge No</span>
                <input value={belgeNo} maxLength={20} onChange={e => setBelgeNo(e.target.value)} /></label>
              <label className="hc-alan"><span>Açıklama</span>
                <input value={aciklama} maxLength={200} onChange={e => setAciklama(e.target.value)}
                  placeholder="İsteğe bağlı" /></label>
              <div className="hc-modal-alt">
                <button type="button" className="btn btn-secondary" onClick={() => setPencere(null)}>Vazgeç</button>
                <button type="button" className="btn btn-primary" onClick={kaydet} disabled={islemde}>
                  {islemde ? 'Kaydediliyor...' : (pencere.tahsilat ? 'Tahsilatı Al' : 'Ödemeyi Yap')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tahakkuk penceresi — VB6 SSPanel11 */}
      {tahakkuk && cari && (
        <div className="hc-modal-zemin" onClick={() => setTahakkuk(null)} role="presentation">
          <div className="hc-modal" onClick={e => e.stopPropagation()} role="presentation">
            <div className="hc-modal-bas">
              <strong>TAHAKKUK İŞLEMİ — {cari.adSoy}</strong>
              <button type="button" onClick={() => setTahakkuk(null)}>✕</button>
            </div>
            <div className="hc-modal-govde">
              <div className="hc-secim">
                <button type="button" className={`hc-sec ${tahakkuk.borc ? 'aktif' : ''}`}
                  onClick={() => setTahakkuk({ borc: true })}>BORÇ Tahakkuku (Borçlandır)</button>
                <button type="button" className={`hc-sec ${!tahakkuk.borc ? 'aktif' : ''}`}
                  onClick={() => setTahakkuk({ borc: false })}>ALACAK Tahakkuku (Alacaklandır)</button>
              </div>
              <label className="hc-alan"><span>Tutar (TL)</span>
                <input type="number" step="0.01" min={0} autoFocus value={tutar}
                  onChange={e => setTutar(e.target.value)} /></label>
              <label className="hc-alan"><span>Belge No</span>
                <input value={belgeNo} maxLength={20} onChange={e => setBelgeNo(e.target.value)} /></label>
              <label className="hc-alan"><span>Açıklama</span>
                <input value={aciklama} maxLength={150} onChange={e => setAciklama(e.target.value)}
                  placeholder={tahakkuk.borc ? 'Borçlandırma' : 'Alacaklandırma'} /></label>
              <div className="hc-modal-alt">
                <button type="button" className="btn btn-secondary" onClick={() => setTahakkuk(null)}>Vazgeç</button>
                <button type="button" className="btn btn-primary" onClick={tahakkukKaydet} disabled={islemde}>
                  {islemde ? 'Kaydediliyor...' : 'ONAYLA'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bakiyeli hastalar — VB6 SSPanel3 */}
      {bakiyeli && (
        <div className="hc-modal-zemin" onClick={() => setBakiyeli(null)} role="presentation">
          <div className="hc-modal genis" onClick={e => e.stopPropagation()} role="presentation">
            <div className="hc-modal-bas">
              <strong>BAKİYELİ HASTALAR</strong>
              <button type="button" onClick={() => setBakiyeli(null)}>✕</button>
            </div>
            <div className="hc-modal-govde">
              <div className="hc-secim">
                {[['borclu', 'Borçlular'], ['alacakli', 'Alacaklılar'], ['tumu', 'Her İkisi']].map(([k, ad]) => (
                  <button key={k} type="button" className={`hc-sec ${bakiyeliDurum === k ? 'aktif' : ''}`}
                    onClick={() => bakiyeliGetir(k)}>{ad}</button>
                ))}
                <button type="button" className="hc-sec" onClick={bakiyeleriYenile} disabled={islemde}
                  title="Tüm hasta kartlarının bakiyesini cari hareketlerden yeniden hesaplar">
                  Hesap Kartlarını Yeniden Düzenle
                </button>
              </div>
              <p className="hc-modal-not">
                {bakiyeli.liste.length} hasta · Toplam: <b>{para(bakiyeli.toplam)} TL</b>
                {' '}(artı değer hastanın BORCU, eksi değer hastaya İADE demektir)
              </p>
              <div className="hc-bakiyeli-liste">
                <table>
                  <thead><tr><th>Hasta No</th><th>Hasta Adı</th><th className="sag">Bakiyesi</th></tr></thead>
                  <tbody>
                    {bakiyeli.liste.length === 0 && <tr><td colSpan={3} className="hc-bos">Kayıt yok.</td></tr>}
                    {bakiyeli.liste.map(b => (
                      <tr key={b.kayitNo} onClick={() => {
                        setSecili({ kayitNo: b.kayitNo, adSoy: b.adSoy });
                        setBakiyeli(null);
                      }}>
                        <td>{b.kayitNo}</td>
                        <td className="hc-ad">{b.adSoy}</td>
                        <td className={`sag ${b.bakiye > 0 ? 'kirmizi' : 'yesil'}`}>{para(b.bakiye)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
